export const integrationsIndexEnUS = {
  integration: 'Integration',
}

export const integrationsIndexEsMX = {
  integration: 'Integración',
}
